export default __webpack_public_path__ + "static/media/whiteFront3.9c2d9cff.png";